export default __webpack_public_path__ + "static/media/data_center_overview_v2.4c89c39e.png";